import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AccountsSection from 'features/accounts/sections/AccountsSection';
import AccountDetail from 'features/accounts/pages/AccountDetail';
import RolesChecker from "features/customer/components/RolesChecker";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { useTranslation } from "react-i18next";

interface Props {}

const Accounts = (props: Props) => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const match = useRouteMatch();

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;

  return (
    <RolesChecker enabledRoles="Admin">
      <Switch>
        <Route path={`${match.path}/:id`} component={AccountDetail} /> 
        <Route path={match.path}>
          <Header title={tLabels("accounts.title")} includeBreadcrumbs />
          <ModuleContent>
            <AccountsSection customerId={customer.customerId!} />
          </ModuleContent>
        </Route>
      </Switch>
    </RolesChecker>
  );
};

export default Accounts;
